module.exports = "<p>\n  enterprise works!\n</p>\n"